import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Treinamentos = () => {
  const [filtroCategoria, setFiltroCategoria] = useState('todos');
  const [filtroModalidade, setFiltroModalidade] = useState('todos');

  const categorias = [
    { id: 'todos', nome: 'Todos os Treinamentos' },
    { id: 'lideranca', nome: 'Liderança' },
    { id: 'vendas', nome: 'Vendas' },
    { id: 'atendimento', nome: 'Atendimento' },
    { id: 'gestao', nome: 'Gestão' },
    { id: 'desenvolvimento', nome: 'Desenvolvimento Pessoal' },
    { id: 'comunicacao', nome: 'Comunicação' }
  ];

  const treinamentos = [
    {
      id: 1,
      titulo: 'Liderança Transformadora',
      categoria: 'lideranca',
      modalidade: 'presencial',
      duracao: '16 horas',
      preco: 'R$ 890,00',
      descricao: 'Desenvolva habilidades de liderança que transformam equipes e resultados.',
      objetivos: [
        'Desenvolver competências de liderança',
        'Aprender técnicas de motivação de equipes',
        'Implementar estratégias de comunicação eficaz',
        'Criar um ambiente de alta performance'
      ],
      publico: 'Gestores, supervisores e líderes de equipe',
      certificacao: true,
      destaque: true
    },
    {
      id: 2,
      titulo: 'Vendas de Alta Performance',
      categoria: 'vendas',
      modalidade: 'online',
      duracao: '12 horas',
      preco: 'R$ 650,00',
      descricao: 'Técnicas avançadas de vendas para aumentar sua performance e resultados.',
      objetivos: [
        'Dominar o processo de vendas consultivas',
        'Desenvolver técnicas de negociação',
        'Aprender a lidar com objeções',
        'Criar relacionamentos duradouros com clientes'
      ],
      publico: 'Vendedores, consultores comerciais e empreendedores',
      certificacao: true,
      destaque: false
    },
    {
      id: 3,
      titulo: 'Excelência no Atendimento ao Cliente',
      categoria: 'atendimento',
      modalidade: 'hibrido',
      duracao: '8 horas',
      preco: 'R$ 450,00',
      descricao: 'Transforme o atendimento em diferencial competitivo da sua empresa.',
      objetivos: [
        'Compreender as expectativas dos clientes',
        'Desenvolver habilidades de comunicação',
        'Aprender técnicas de resolução de conflitos',
        'Criar experiências memoráveis para clientes'
      ],
      publico: 'Profissionais de atendimento, recepcionistas e vendedores',
      certificacao: true,
      destaque: true
    },
    {
      id: 4,
      titulo: 'Gestão do Tempo e Produtividade',
      categoria: 'gestao',
      modalidade: 'online',
      duracao: '6 horas',
      preco: 'R$ 380,00',
      descricao: 'Otimize seu tempo e aumente sua produtividade pessoal e profissional.',
      objetivos: [
        'Identificar ladrões de tempo',
        'Aprender técnicas de priorização',
        'Implementar ferramentas de organização',
        'Desenvolver hábitos produtivos'
      ],
      publico: 'Profissionais de todas as áreas',
      certificacao: true,
      destaque: false
    },
    {
      id: 5,
      titulo: 'Inteligência Emocional no Trabalho',
      categoria: 'desenvolvimento',
      modalidade: 'presencial',
      duracao: '12 horas',
      preco: 'R$ 720,00',
      descricao: 'Desenvolva sua inteligência emocional para melhorar relacionamentos e performance.',
      objetivos: [
        'Compreender as emoções e seus impactos',
        'Desenvolver autoconhecimento',
        'Aprender a gerenciar emoções',
        'Melhorar relacionamentos interpessoais'
      ],
      publico: 'Líderes, gestores e profissionais em geral',
      certificacao: true,
      destaque: true
    },
    {
      id: 6,
      titulo: 'Comunicação Assertiva e Persuasiva',
      categoria: 'comunicacao',
      modalidade: 'hibrido',
      duracao: '10 horas',
      preco: 'R$ 580,00',
      descricao: 'Aprenda a se comunicar de forma clara, assertiva e persuasiva.',
      objetivos: [
        'Desenvolver habilidades de comunicação',
        'Aprender técnicas de persuasão ética',
        'Melhorar a comunicação não-verbal',
        'Criar apresentações impactantes'
      ],
      publico: 'Profissionais que precisam se comunicar efetivamente',
      certificacao: true,
      destaque: false
    },
    {
      id: 7,
      titulo: 'Gestão de Conflitos e Negociação',
      categoria: 'gestao',
      modalidade: 'presencial',
      duracao: '14 horas',
      preco: 'R$ 780,00',
      descricao: 'Transforme conflitos em oportunidades através de técnicas de negociação.',
      objetivos: [
        'Compreender a natureza dos conflitos',
        'Aprender técnicas de mediação',
        'Desenvolver habilidades de negociação',
        'Criar soluções win-win'
      ],
      publico: 'Gestores, líderes e profissionais de RH',
      certificacao: true,
      destaque: false
    },
    {
      id: 8,
      titulo: 'Desenvolvimento de Equipes de Alto Desempenho',
      categoria: 'lideranca',
      modalidade: 'online',
      duracao: '18 horas',
      preco: 'R$ 950,00',
      descricao: 'Construa e lidere equipes que entregam resultados excepcionais.',
      objetivos: [
        'Compreender dinâmicas de equipe',
        'Desenvolver estratégias de engajamento',
        'Aprender a delegar efetivamente',
        'Criar cultura de alta performance'
      ],
      publico: 'Gestores, diretores e líderes de equipe',
      certificacao: true,
      destaque: true
    }
  ];

  const treinamentosFiltrados = treinamentos.filter(treinamento => {
    const categoriaMatch = filtroCategoria === 'todos' || treinamento.categoria === filtroCategoria;
    const modalidadeMatch = filtroModalidade === 'todos' || treinamento.modalidade === filtroModalidade;
    return categoriaMatch && modalidadeMatch;
  });

  const treinamentosDestaque = treinamentos.filter(t => t.destaque);

  return (
    <div className="pt-32 bg-focus-white min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-blue to-blue-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Catálogo de Treinamentos
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-8">
            Desenvolva suas competências e transforme sua carreira com nossos treinamentos especializados
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold">50+</div>
              <div className="text-sm">Treinamentos Disponíveis</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold">5000+</div>
              <div className="text-sm">Profissionais Treinados</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold">98%</div>
              <div className="text-sm">Satisfação dos Participantes</div>
            </div>
          </div>
        </div>
      </section>

      {/* Treinamentos em Destaque */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
            Treinamentos em Destaque
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {treinamentosDestaque.map((treinamento) => (
              <div key={treinamento.id} className="bg-gradient-to-br from-focus-orange to-red-600 rounded-lg p-6 text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 bg-yellow-400 text-focus-blue px-3 py-1 rounded-bl-lg text-sm font-bold">
                  DESTAQUE
                </div>
                <h3 className="text-lg font-bold mb-2 mt-4">{treinamento.titulo}</h3>
                <p className="text-sm text-red-100 mb-4">{treinamento.descricao}</p>
                <div className="flex justify-between items-center">
                  <span className="text-xl font-bold">{treinamento.preco}</span>
                  <span className="text-sm bg-white/20 px-2 py-1 rounded">{treinamento.duracao}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filtros */}
      <section className="py-8 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-semibold text-focus-blue mb-4">Filtrar Treinamentos</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Categoria
                </label>
                <select
                  value={filtroCategoria}
                  onChange={(e) => setFiltroCategoria(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                >
                  {categorias.map((categoria) => (
                    <option key={categoria.id} value={categoria.id}>
                      {categoria.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Modalidade
                </label>
                <select
                  value={filtroModalidade}
                  onChange={(e) => setFiltroModalidade(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                >
                  <option value="todos">Todas as Modalidades</option>
                  <option value="presencial">Presencial</option>
                  <option value="online">Online</option>
                  <option value="hibrido">Híbrido</option>
                </select>
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-600">
              Mostrando {treinamentosFiltrados.length} de {treinamentos.length} treinamentos
            </div>
          </div>
        </div>
      </section>

      {/* Catálogo de Treinamentos */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {treinamentosFiltrados.map((treinamento) => (
              <div key={treinamento.id} className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-focus-blue mb-2">
                        {treinamento.titulo}
                      </h3>
                      <div className="flex flex-wrap gap-2 mb-3">
                        <span className="bg-focus-pink text-focus-blue px-2 py-1 rounded-full text-xs font-medium">
                          {categorias.find(c => c.id === treinamento.categoria)?.nome}
                        </span>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          treinamento.modalidade === 'presencial' ? 'bg-green-100 text-green-800' :
                          treinamento.modalidade === 'online' ? 'bg-blue-100 text-blue-800' :
                          'bg-purple-100 text-purple-800'
                        }`}>
                          {treinamento.modalidade === 'presencial' ? 'Presencial' :
                           treinamento.modalidade === 'online' ? 'Online' : 'Híbrido'}
                        </span>
                        {treinamento.certificacao && (
                          <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                            Certificado
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-bold text-focus-orange">
                        {treinamento.preco}
                      </div>
                      <div className="text-sm text-gray-600">
                        {treinamento.duracao}
                      </div>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 mb-4">
                    {treinamento.descricao}
                  </p>
                  
                  <div className="mb-4">
                    <h4 className="font-semibold text-focus-blue mb-2">Objetivos:</h4>
                    <ul className="space-y-1">
                      {treinamento.objetivos.slice(0, 3).map((objetivo, index) => (
                        <li key={index} className="flex items-start text-sm text-gray-600">
                          <svg className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          {objetivo}
                        </li>
                      ))}
                      {treinamento.objetivos.length > 3 && (
                        <li className="text-sm text-gray-500 ml-6">
                          +{treinamento.objetivos.length - 3} objetivos adicionais
                        </li>
                      )}
                    </ul>
                  </div>
                  
                  <div className="mb-6">
                    <h4 className="font-semibold text-focus-blue mb-1">Público-alvo:</h4>
                    <p className="text-sm text-gray-600">{treinamento.publico}</p>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-3">
                    <button className="flex-1 bg-focus-blue hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors">
                      Inscrever-se
                    </button>
                    <button className="flex-1 border border-focus-blue text-focus-blue hover:bg-focus-blue hover:text-white px-4 py-2 rounded-lg font-semibold transition-colors">
                      Mais Informações
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modalidades de Treinamento */}
      <section className="py-16 bg-focus-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
            Modalidades Disponíveis
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-focus-blue mb-3">Presencial</h3>
              <p className="text-gray-600 mb-4">
                Treinamentos realizados em nossa sede ou in-company, com interação direta e networking.
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Interação face a face</li>
                <li>• Networking com outros participantes</li>
                <li>• Atividades práticas em grupo</li>
                <li>• Material físico incluso</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-focus-blue mb-3">Online</h3>
              <p className="text-gray-600 mb-4">
                Treinamentos 100% online com plataforma interativa e suporte em tempo real.
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Flexibilidade de horário</li>
                <li>• Acesso de qualquer lugar</li>
                <li>• Gravações disponíveis</li>
                <li>• Custo reduzido</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-focus-blue mb-3">Híbrido</h3>
              <p className="text-gray-600 mb-4">
                Combinação de aulas presenciais e online para máxima flexibilidade e aproveitamento.
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Melhor dos dois mundos</li>
                <li>• Flexibilidade personalizada</li>
                <li>• Acompanhamento contínuo</li>
                <li>• Resultados otimizados</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios dos Treinamentos */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
            Por que escolher nossos treinamentos?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-focus-orange rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-focus-blue mb-2">Certificação Reconhecida</h3>
              <p className="text-gray-600 text-sm">
                Certificados válidos em todo território nacional
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-focus-orange rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-focus-blue mb-2">Instrutores Especialistas</h3>
              <p className="text-gray-600 text-sm">
                Profissionais com vasta experiência de mercado
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-focus-orange rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-focus-blue mb-2">Metodologia Prática</h3>
              <p className="text-gray-600 text-sm">
                Aprendizado baseado em casos reais e exercícios práticos
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-focus-orange rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-focus-blue mb-2">Suporte Contínuo</h3>
              <p className="text-gray-600 text-sm">
                Acompanhamento pós-treinamento para garantir resultados
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 bg-gradient-to-r from-focus-blue to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Pronto para transformar sua carreira?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e descubra como nossos treinamentos podem acelerar seu crescimento profissional.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-focus-orange hover:bg-red-600 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Fale Conosco
            </Link>
            <button className="border-2 border-white text-white hover:bg-white hover:text-focus-blue px-8 py-3 rounded-lg text-lg font-semibold transition-colors">
              Baixar Catálogo Completo
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-2xl font-bold mb-2">📞 (61) 9170-8150</div>
              <div className="text-blue-100">Atendimento comercial</div>
            </div>
            <div>
              <div className="text-2xl font-bold mb-2">📧 treinamentos@focus.com.br</div>
              <div className="text-blue-100">Email para inscrições</div>
            </div>
            <div>
              <div className="text-2xl font-bold mb-2">💬 WhatsApp</div>
              <div className="text-blue-100">(61) 9170-8150</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Treinamentos;